
export function returnRoleType(roleId: number) {
  if (roleId === 1) return 'Contributor';
  else if (roleId === 2) return 'Viewer';
  return 'Owner';
}
